import { Monitoring, provideFrontendInit, provideFrontendSentryMethods } from "@movinglayers/monitoring/frontend";
import { App } from "vue";
import { environment } from "../../environments/environment.ts";

export const initSentry = (app: App) => {

    const env = environment.environment;

    const options = {
        app,
        dsn: "https://ccf70de688d6c6eb5e2d8c705b38b71d@o4507222280044544.ingest.de.sentry.io/4508846446149712",
        environment: env,
        release: environment.BUILD_VERSION,
        enabled: env === "local"
    };

    Monitoring.initialize(
        options,
        provideFrontendSentryMethods(),
        provideFrontendInit(options)
    );
};